import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { TalkingPointsContext } from '..';
import { skins } from '../skins';
const { black } = skins;
const {
    LR_LOGO_PATH,
    EQUAL_HOUSING_LOGO_PATH,
} = black;
const COPYRIGHT_YEAR = new Date().getFullYear();

const useStyles = makeStyles(()=> ({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
        fontSize: '24px',
    },
    buttonContainer: {
        position: 'absolute',
        left: 74,
        top: 283,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    customButton: {
        background: '#1EC8E1',
        color: '#FFFFFF',
        width: '322px',
        height: '68px',
        borderRadius: '8px',
        borderColor: 'transparent',
        fontSize: '28px',
        fontWeight: '700',
        lineHeight: '20px',
        textAlign: 'center',
        boxShadow: '8px 8px rgba(0, 0, 0, 0.25)',
    },
    userProfileContainer: {
        position: 'absolute',
        left: 74,
        top: 347,
        width: 500,
        height: 126,
        padding: '16px 16px 16px 0',
        lineHeight: '1.4em',
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        textAlign: 'left',
        boxSizing: 'border-box',
    },
    userName: {
        fontWeight: 900,
    },
    dateContainer: {
        position: 'absolute',
        top: 40,
        right: 44,
        textAlign: 'right',
        fontWeight: 600,
    },
    imagesWrapper: {
        position: 'absolute',
        width: 450,
        height: 280,
        bottom: 19,
        right: 19,
    },
    imagesContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    imageWrap: {
        position: 'absolute',
        width: 385,
        height: 256,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    image0: {
        right: -14,
        bottom: -48,
    },
    image1: {
        right: -110,
        bottom: 6,
    },
    image2: {
        right: 65,
        bottom: -120,
    },
    disclaimer: {
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
        position: 'absolute',
        left: 74,
        bottom: 34,
        textAlign: 'left',
        fontSize: '14px',
        lineHeight: '20px',
    },
    equalHousingLogo: {
        marginLeft: 12,
    },
    disclaimerCopyright: {
        marginTop: 4,
    }
}));

export const Black = ()=> {
    const {
        user: {
            name,
        } = {},
        images,
        dateStr,
    } = useContext(TalkingPointsContext);
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.dateContainer}>
                {dateStr}
            </div>
            <div className={classes.buttonContainer}>
                <button className={classes.customButton}>See the full report</button>
            </div>
            <div className={classes.userProfileContainer}>
                {name && (
                    <div className={classes.userProfileName}>
                        Brought to you by<br/>
                        <div className={classes.userName}>{name}</div>
                    </div>
                )}
            </div>
            <div className={classes.imagesWrapper}>
                <div className={classes.imagesContainer}>
                    {(images.length > 1 && images[1]?.length) && (<div className={`${classes.imageWrap} ${classes.image1}`} style={{
                        backgroundImage: `url("${images[1]}")`,
                    }}></div>)}

                    {(images.length > 0 && images[0]?.length) && (<div className={`${classes.imageWrap} ${classes.image0}`} style={{
                        backgroundImage: `url("${images[0]}")`,
                    }}></div>)}

                    {(images.length > 2 && images[2]?.length) && (<div className={`${classes.imageWrap} ${classes.image2}`} style={{
                        backgroundImage: `url("${images[2]}")`,
                    }}></div>)}
                </div>
            </div>

            <div className={classes.disclaimer}>
                <div>
                    <img src={LR_LOGO_PATH} height={14} alt="ListReports" />
                    <img className={classes.equalHousingLogo} src={EQUAL_HOUSING_LOGO_PATH} height={17} alt="Equal Housing Opportunity" />
                </div>
                <div className={classes.disclaimerCopyright}>
                    &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved.
                </div>
            </div>
        </div>
    );
};
